export default __webpack_public_path__ + "static/media/port.3d9451aa.png";